import Link from 'next/link';
import Button from '../components/General/Button';
import Image from 'next/image';

export default function FourOhFour() {
    return <div className='flex justify-center items-center flex-col' style={{ height: 'calc(100vh - 70px)' }}>

        <img src={'/logo.png'} width={200} height={200} alt="" className='my-4' />
        <h1 className='text-[30px] font-semibold'>404 Error</h1>
        <p>:( Could not find this page!</p>

        <div className='my-4'>
            <Button
                styles='
                            w-full 
                            text-white 
                            bg-theme-orange 
                            h-12 
                            lg:w-[150px] 
                            my-4 
                            lg:justify-self-end
                            lg:place-self-end
                            lg:my-0
                            '
                destinationEvent=""
            >
                <Link href="/">
                    Back to home
                </Link>
            </Button>
        </div>
    </div>
}